import notEmptyAttribute from '@model/_shared/validator/notEmptyAttribute'

export const validators = {
  serial: notEmptyAttribute,
  hardwareVersion: notEmptyAttribute,
  firmwareVersion: notEmptyAttribute,
}

export {
  validators as default,
}
